window.$ = window.jQuery = require('jquery');
// var Hammer = require('hammerjs');
import Player from '../player';

(function () {
    var $carruselPrincipal = $("#carrusel-principal");
    var $ctrCen = $("#ctr-carrusel-central");
    var $carrusel = $(".carrusel");
    var tmsg = $ctrCen.find(".anuncio").length;
    var $control = $ctrCen.find(".control");
    var apuntado = 0;
    var animando = false;
    var tempo = null;

    var $videos = $carruselPrincipal.find(".video");
    var players = {};
    var $players = [];
    if ($videos.length > 0) {
        $videos.each(function( index ) {
            var attr = $(this).attr('data-central');
            var player;

            if (typeof attr !== 'undefined' && attr !== false) {
                player = new Player($(this), false, false);
                players[attr] = player;
                $players.push($(this));
            } else {
                new Player($(this), false, false);
            }
        });
    }

    function quitarListnersVideos() {
        $.each($players, function(index, $player) {
            $player.off("video-finalizado");
        });
    }

    $carrusel.each(function () {
        $(this).find(".anuncio").first().addClass("seleccionado");
    });

    var $primerVideo = $ctrCen.find(".anuncio.seleccionado .video[data-central]");
    if ($primerVideo.length > 0) {
        players[$primerVideo.attr("data-central")].playEnListo();
        $primerVideo.on("video-finalizado", function () {
            avanzar();
            $primerVideo.off("video-finalizado");
        })
    }

    function arrancar() {
        if (tmsg > 1) {
            tempo = window.setTimeout(avanzar, 10000);
        }
    }

    function avanzar() {
        var ultimo = tmsg - 1;

        var posterior = apuntado + 1;
        if (posterior > ultimo) {
            posterior = 0;
        }
        mover(posterior);
    }

    function mover(indice) {
        quitarListnersVideos();

        if (indice === apuntado || animando === true) {
            return;
        }
        animando = true;
        window.clearTimeout(tempo);
        var ultimo = tmsg - 1;
        var dir = "izq";

        if (apuntado === 0 && indice === ultimo) {
            dir = "der";
        } else if (apuntado === ultimo && indice === 0) {
            dir = "izq";
        } else if (indice < apuntado) {
            dir = "der";
        } else if (indice > apuntado) {
            dir = "izq";
        }

        var tieneVideo = false;
        $carrusel.each(function () {
            var $apuntado = $(this).find(".anuncio").eq(apuntado);
            var $proximo = $(this).find(".anuncio").eq(indice);

            $apuntado.removeClass("entrante-izq").removeClass("entrante-der").removeClass("seleccionado");
            $proximo.removeClass("saliente-izq").removeClass("saliente-der");
            $apuntado.addClass("saliente-" + dir);
            $proximo.addClass("entrante-" + dir).addClass("seleccionado");

            var $videoApuntado = $apuntado.find("[data-central]");
            if ($videoApuntado.length > 0) {
                window.setTimeout(function () {
                    players[$videoApuntado.attr("data-central")].parar();
                }, 1000);
            }

            var $videoProximo = $proximo.find("[data-central]");
            if ($videoProximo.length > 0) {
                tieneVideo = true;
                players[$videoProximo.attr("data-central")].replay();
                $videoProximo.on("video-finalizado", function () {
                    if (tmsg > 1) {
                        animando = false;
                        avanzar();
                    }
                })
            }
        });

        $control.find("span").eq(apuntado).removeClass("btn-control-activo").addClass("btn-control");
        $control.find("span").eq(indice).removeClass("btn-control").addClass("btn-control-activo");

        window.setTimeout(function () {
            animando = false;
        }, 1000);
        apuntado = indice;
        if (!tieneVideo) {
            arrancar();
        }
    }

    function aLaIzquierda() {
        var anterior = apuntado - 1;

        if (anterior < 0) {
            anterior = tmsg - 1;
        }

        mover(anterior);
    }

    function aLaDerecha() {
        var ultimo = tmsg - 1;
        var posterior = apuntado + 1;
        if (posterior > ultimo) {
            posterior = 0;
        }
        mover(posterior);
    }

    $ctrCen.on("click", ".izq", aLaIzquierda);

    $ctrCen.on("click", ".der", aLaDerecha);

    // var hammertime = new Hammer($ctrCen[0]);
    // hammertime.on('swipeleft', aLaDerecha);
    // hammertime.on('swiperight', aLaIzquierda);

    $control.on("click", "li", function () {
        mover($(this).index());
    });

    // function ajustar() {
    //     var ancho = $ctrCen.width();
    //     var alto = ancho / 16 * 9;
    //     $carrusel.width(ancho).height(alto);
    //     $carrusel.find(".anuncio").width(ancho).height(alto);
    // }
    //
    // $(window).resize(ajustar);
    // ajustar();

    if ($primerVideo.length === 0) {
        arrancar();
    }

    $carruselPrincipal.find("[data-anuncio-url]").on("click", function () {
        window.location.href = $(this).attr("data-anuncio-url");
    });
})();